import React, {useEffect} from 'react';

const PositionSummary = ({candidate, position}) => {

    let proposedStartedAt = TB.moment(position.startedAt()).format('MM/DD/YYYY');

    let proposedHrsPerWeek = parseInt(candidate.job_candidate?.confirmed_avg_hours_per_period || position.avg_hours_per_period);
    let estimatedTotalHours = candidate.job_candidate?.total_hours;

    let estimatedFee = TB.formatCurrency(position.platform_cost, false)
    let proposedFee = TB.formatCurrency(candidate.job_candidate?.platform_cost, false);

    useEffect(() => {
        console.log(candidate.job_candidate)

    }, []);

    return (
        <div className="est-brief">

            <div className="est-brief-info">

                {candidate.isTimeMaterials() && (
                    <React.Fragment>
                        <div className="est-brief-section">
                            <p className="est-brief-section-label">
                                Proposed Rate
                            </p>

                            <p className="est-brief-section-value">
                                <span>
                                    {candidate.proposedPlatformRate()}/hr
                                </span>
                            </p>
                        </div>
                        <div className="est-brief-section">
                            <p className="est-brief-section-label">
                                Start Date
                            </p>

                            <p className={TB.mapClass("est-brief-section-value", {
                                "proposed": candidate.changedStartDate(position)
                            })}>
                                {candidate.changedStartDate(position) && (
                                    <span className="estimate">
                                        {TB.moment(position.started_at).format("MM/DD/YYYY")}
                                    </span>
                                )}
                                <span>
                                    {proposedStartedAt}
                                </span>
                            </p>
                        </div>
                        <div className="est-brief-section">
                            <p className="est-brief-section-label">
                                Avg Hours Per Week
                            </p>

                            <p className={TB.mapClass("est-brief-section-value", {
                                "proposed": candidate.changedAvgHoursPerWeek(position)
                            })}>
                                {candidate.changedAvgHoursPerWeek(position) && (
                                    <span className="estimate">
                                        {position.avg_hours_per_period}
                                    </span>
                                )}
                                <span>
                                    {proposedHrsPerWeek}
                                </span>
                            </p>
                        </div>
                    </React.Fragment>
                )}

                {candidate.isFixedRetainer() ? (
                    <React.Fragment>
                        <div className="est-brief-section">
                            <p className="est-brief-section-label">
                                Est Cost per {position.payout_frequency === 'weekly' ? 'Week': 'Month'}
                            </p>
                            <p className={TB.mapClass("est-brief-section-value", {
                                "proposed": position.calculateFixedRetainerBudgetPerPeriod() && candidate.proposedPlatformPayoutPerPeriod(position.isFixedRetainerRateBased(), false) !== position.payout_amount
                            })}>
                                {position.calculateFixedRetainerBudgetPerPeriod() && candidate.proposedPlatformPayoutPerPeriod(position.isFixedRetainerRateBased(), false) !== position.calculateFixedRetainerBudgetPerPeriod() && (
                                    <span className="estimate">
                                        {TB.formatCurrency(position.calculateFixedRetainerBudgetPerPeriod())}
                                    </span>
                                )}
                                <span>
                                    {candidate.proposedPlatformPayoutPerPeriod(position.isFixedRetainerRateBased())}
                                </span>
                            </p>
                        </div>
                        <div className="est-brief-section">
                            <p className="est-brief-section-label">
                                Total Periods
                            </p>
                            <p className={"est-brief-section-value"}>
                                {position.payoutFrequencyLabel()}
                            </p>
                        </div>
                    </React.Fragment>
                ) : (
                    <div className="est-brief-section">
                        <p className="est-brief-section-label">
                            Est Total Hours
                        </p>
                        <p className={TB.mapClass("est-brief-section-value", {
                            "proposed": candidate.job_candidate?.total_hours !== position.estimated_total_periods
                        })}>
                            {candidate.job_candidate?.total_hours !== position.estimated_total_periods && (
                                <span className="estimate">
                                    {position.estimated_total_periods}
                                </span>
                            )}
                            <span>
                                {estimatedTotalHours}
                            </span>
                        </p>
                    </div>
                )}

                <div className="est-brief-section">
                    <p className="est-brief-section-label">
                        Estimated Fee
                    </p>
                    <p className={TB.mapClass("est-brief-section-value", {
                        "proposed": estimatedFee !== proposedFee
                    })}>
                        {proposedFee !== estimatedFee && (
                            <span className="estimate">
                                {estimatedFee}
                            </span>
                        )}
                        {proposedFee}
                    </p>
                </div>
            </div>
        </div>
    );
};

PositionSummary.propTypes = {};

export default PositionSummary;